import Vue from "vue";
import App from "./App.vue";
// 该文件专门用于创建整个应用的路由器
import Router from "vue-router";
// 引入路由
import router from "./router";
// 引入store
import store from "./store";
// 引入element-ui的js
import ElementUI from "element-ui";
import { getToken } from "@/utils/auth";
// 引入element-ui的样式
import("element-ui/lib/theme-chalk/index.css");
// 引入echarts
import * as echarts from "echarts";
// 引入audioPlayer插件
// import audioplayer from './utils/audioplayer'
import loadingViewerVue from "loading-view-vue";
Vue.use(loadingViewerVue);

Vue.use(Router);

import VuePageStack from "vue-page-stack";

Vue.use(VuePageStack, { router });

Vue.use(ElementUI, { size: "mini" });
// Vue.use(audioplayer)

// 引入axios方法
// import {Login} from './api/user'
// import { getToken, removeToken, setToken } from './utils/auth'

Vue.config.productionTip = false;

// if (getToken('appraisalUser')) {
//     store.commit('CREATEAPPRAISALUSER', JSON.parse(getToken('appraisalUser')))
// }
import countModalBox from '@/api/count_time.js'
// Vue.use(countModal)
new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$echarts = echarts; //全局引入echarts
    Vue.prototype.$countModal=countModalBox()
  },
}).$mount("#app");

window.myrouter=router;
window.refresh_time = Date.now();
// window.$countModal=countModalBox
//3分钟检查一次，除了首页，其他页面无操作超过3分钟，返回首页,每10s检查一次
var ref_time = setInterval(function () {// * 60*3
  if (Date.now() - window.refresh_time > 1000*60*1) {//30
    if (getToken("account")) {       
      console.log("跳转");
      if(router.currentRoute.name!='modulelist'){
        // console.log(window.$countModal)  
        console.log(Vue.prototype)
        // window.$countModal.OpenDialog()
        // router.replace({
        //   name: "modulelist",
        //   params: {
        //     account: getToken("account"),
        //   },
        // });
        if(!Vue.prototype.$countModal.isShow){
          Vue.prototype.$countModal.OpenDialog();
        }        
      }      
    }
  }  
}, 1000 * 10);
// console.log('router:',router)
window.refresh = function (e) {
  window.refresh_time = Date.now();
  // console.log(e, window.refresh_time);
};

document.addEventListener("keydown", window.refresh);
document.addEventListener("touchmove", window.refresh);
document.addEventListener("mousemove", window.refresh);
document.addEventListener("click", window.refresh);

// import $ from 'jquery'
// window.$=$